<template>
  <div class="login-form">
    <form name="form" @submit.prevent="handleLogin">
      <legend class="uk-legend uk-text-center">Log in</legend>
      <div class="uk-margin">
        <div class="uk-forms-controls">
          <label class="uk-form-label">Email</label>
          <input
            :class="{
              'uk-input': true,
              'uk-form-danger': errors.has('email')
            }"
            type="text"
            name="email"
            v-model="user.email"
            v-validate="`required|email|max:50`"
          >
        </div>
        <div v-if="errors.has('email')" class="uk-text-danger uk-text-small">{{errors.first('email')}}</div>
      </div>
      <div class="uk-margin">
         <div class="uk-form-controls">
            <label class="uk-form-label">Password</label>
            <input
              :class="{
                'uk-input': true,
                'uk-form-danger': errors.has('password')
              }"
              type="password"
              name="password"
              v-model="user.password"
              v-validate="`required|min:8|max:20`"
            >
         </div>
         <div v-if="errors.has('password')" class="uk-text-danger uk-text-small">{{errors.first('password')}}</div>
      </div>
      <div class="uk-margin">
         <div uk-spinner v-show="loading"></div>
         <button class="uk-button uk-button-primary uk-width-1-1" :disabled="loading">Log In</button>
      </div>
      <p v-if="message" class="uk-text-center uk-text-danger uk-text-small">{{message}}</p>
      <p class="text-center link"><router-link to="/register">Register</router-link><br/><router-link to="/forgot">Forgot your password?</router-link></p>
    </form>
  </div>
</template>

<script>
import User from '../models/user';
export default {
    name: 'Login',
    data() {
      return {
        user: new User('', ''),
        loading: false,
        message: ''
      }
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
    created() {
      if (this.loggedIn) {
        this.$router.push({name: 'dashboard'});
      }
    },
    methods: {
      handleLogin() {
        this.loading = true;
        this.$validator.validate().then(isValid => {
          if (!isValid) {
            this.loading = false;
            return;
          }
          if (this.user.email && this.user.password) {
            this.$store.dispatch('auth/login', this.user).then(
              () => {
                this.$router.push({name: 'dashboard'});
              },
              error => {
                this.loading = false;
                this.message = (error.response && error.response.data.message) ||
                  error.message || error.toString();
              }
            );
          }
        });
      }
    },
}
</script>

<style>

</style>